"use client"

import { useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"

import { useMusicContext } from "@/context/musicContext"

import type { AlbumCardProps } from "./types"

import AlbumImage from "./components/AlbumImage"
import AlbumText from "./components/AlbumText"

export default function PlaylistCardB({
  data,
}: AlbumCardProps) {
  const {
    playlist,
    currentPlaylist,
    currentSong,
    currentSongIndex,
    isPlaying,
    playSong,
  } = useMusicContext()

  const [loaded, setLoaded] = useState(false)

  const bg = data.playlistBg || "#1a1a1a"

  const cardPlaylist = useMemo(() => {
    return playlist.find(
      (item) =>
        item.link === data.link ||
        item.title === data.title ||
        item.id === data.id,
    )
  }, [
    playlist,
    data.id,
    data.link,
    data.title,
  ])

  const isActive =
    !!cardPlaylist &&
    (
      currentPlaylist?.link === cardPlaylist.link ||
      currentPlaylist?.title === cardPlaylist.title
    )

  const isPlayingItem =
    isActive &&
    isPlaying

  const handlePlay = () => {
    if (!cardPlaylist?.playlistData?.length) {
      return
    }

    /*
     * Si ya estamos dentro de esta playlist,
     * mantenemos la canción actual.
     */
    if (isActive && currentSong) {
      return
    }

    playSong(
      cardPlaylist.playlistData[0],
      0,
      cardPlaylist,
    )
  }

  return (
    <motion.div
      className="relative group w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <Link
        to={`/album/${data.link}`}
        className="
          relative
          flex
          items-center
          gap-3
          h-20
          w-full
          rounded-xl
          overflow-hidden
          border
          border-white/5
          bg-white/[0.03]
          transition-colors
          hover:bg-white/[0.06]
        "
      >
        {/* PLAYLIST BACKGROUND */}
        <div
          className="
            absolute
            inset-0
            pointer-events-none
            opacity-10
          "
          style={{
            backgroundColor: bg,
          }}
        />

        {/* COVER */}
        <AlbumImage
          imgUrl={data.imgUrl}
          title={data.title}
          loaded={loaded}
          setLoaded={setLoaded}
          show={isActive}
          isPlaying={isPlayingItem}
          onPlay={handlePlay}
        />

        {/* INFO */}
        <AlbumText
          title={data.title}
          artist={data.artist}
        />
      </Link>
    </motion.div>
  )
}
